import { faHeart as faHeartLight } from "@jewlr/pro-light-svg-icons/faHeart"
import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import { faHeart as faHeartSolid } from "@jewlr/pro-solid-svg-icons/faHeart"
import { Button, FontAwesomeIcon } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import {
  addToWishlist,
  unselectFromWishlist,
} from "areas/collection/store/actions"
import { IS_JEWLR } from "helpers/application"

const WishlistButton = styled(Button).attrs((props) => ({
  bg: "white",
  border: {
    _: `1px solid ${props.theme.colors.grey[300]}`,
    tablet: "none",
  },
  borderRadius: { _: "50%", tablet: "0" },
  height: { _: "34px", tablet: "30px" },
  variant: "text",
  width: { _: "34px", tablet: "30px" },
  ...props,
}))``

const Icon = styled(FontAwesomeIcon).attrs((props) => ({
  color: props.$wishlistAdded
    ? props.theme.colors.wishlist
    : props.theme.colors.blackPrint,
  fontSize: { _: "16px", tablet: "30px" },
}))``

const InternalWishlist = ({
  wishlistAdded,
  wishlistLoading,
  toggleAddToWishlist,
}) => {
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!wishlistLoading) {
      setLoading(wishlistLoading)
    }
  }, [wishlistLoading])

  const wishlistName = IS_JEWLR() ? "wish list" : "collection"

  return (
    <WishlistButton
      aria-label={
        loading
          ? `Loading ${wishlistName}`
          : wishlistAdded
          ? `Remove from ${wishlistName}`
          : `Add to ${wishlistName}`
      }
      disabled={loading}
      id="add-wishlist-btn-main"
      onClick={(e) => {
        if (!loading) {
          setLoading(true)
          toggleAddToWishlist(e)
        }
      }}
    >
      {loading ? (
        <FontAwesomeIcon fontSize="20px" icon={faSpinner} spin />
      ) : (
        <Icon
          $wishlistAdded={wishlistAdded}
          icon={wishlistAdded ? faHeartSolid : faHeartLight}
        />
      )}
    </WishlistButton>
  )
}

InternalWishlist.propTypes = {
  toggleAddToWishlist: PropTypes.func,
  wishlistAdded: PropTypes.bool,
  wishlistLoading: PropTypes.bool,
}

const mapStateToProps = (state) => {
  const styleCode = state.choices.style_code && state.choices.style_code.value
  const wishlistAdded = (state.wishlist.line_items || []).some(
    (line_item) => line_item.style_code === styleCode
  )

  return {
    styleCode,
    wishlistAdded,
    wishlistLoading: state.wishlist.loading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { styleCode, wishlistAdded, wishlistLoading } = stateProps
  const { dispatch } = dispatchProps

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    toggleAddToWishlist: (e) => {
      if (wishlistLoading) return null
      dispatch(
        wishlistAdded
          ? unselectFromWishlist(styleCode)
          : addToWishlist(styleCode, e.selected_look, "Product")
      )
    },
  }
}

const Wishlist = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InternalWishlist)

export default Wishlist
